<template>
  <div class="page dashboard-page">
    <el-row :gutter="15" class="wrapper">
      <el-col :span="24">
        <div class="card section">
          <p class="page-title">管理后台</p>
          <div class="content">
            <div class="item">
              <p class="name">当前角色不能使用管理后台任何功能，如有疑问，请联系管理员</p>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';

  @Component
  export default class NotAnyRoleHome extends Vue {}
</script>

<style lang="scss" scoped>
  .el-row {
    margin-left: 7.5px !important;
    margin-right: 7.5px !important;
  }

  .dashboard-page .wrapper .card .item .name {
    margin-top: 53.5px;
  }
</style>
